import { useTranslation } from 'react-i18next';
import * as apiSupplierRequests from 'api/apiSupplierRequests';
import { useModal } from 'context/ModalContext';
import {
    getButtonsNoYes,
    getButtonsNoYesDanger,
} from 'context/helpers/helperModalContext';
import { useToast } from 'context/ToastContext';
import SvgTrash from 'components/svg/SvgTrash';
import SolarIcon from 'components/icons/SolarIcon';

interface UseRequestStatusActionsParams {
    onChanged: () => void;
}

type DlgButton = {
    title: string;
    variant: string;
    handleClick?: () => void;
};

const useRequestStatusActions = ({ onChanged }: UseRequestStatusActionsParams) => {
    const { t } = useTranslation(['Vendors', 'common']);
    const { showDlg } = useModal();
    const { showToast } = useToast();

    const runAction = async (
        action: () => Promise<{ stat?: boolean } | null>,
        successKey: string,
    ) => {
        const result = await action();
        if (!result?.stat) {
            showToast(t('common:messError'), 'danger');
            return;
        }
        showToast(t(successKey), 'success');
        onChanged();
    };

    const confirmMarkDone = (requestId: number, vendorName?: string) => {
        const buttons = [...getButtonsNoYes(t)] as DlgButton[];
        buttons[1].handleClick = () => {
            showDlg(false);
            void runAction(
                () => apiSupplierRequests.markDone(requestId),
                'supplierRequests.messMarkedDone',
            );
        };

        showDlg({
            type: 'confirm',
            buttons,
            text: (
                <>
                    <h4 className="d-flex pb-2 mb-2 border-bottom">
                        <SolarIcon name="check2-circle" className="fs-4" aria-hidden="true" />
                        <span className="ps-2">{t('supplierRequests.confirmDone')}</span>
                    </h4>
                    {vendorName ? <h5 className="mb-0">{vendorName}</h5> : null}
                </>
            ),
        });
    };

    const confirmMarkDeleted = (requestId: number, vendorName?: string) => {
        const buttons = [...getButtonsNoYesDanger(t)] as DlgButton[];
        buttons[1].handleClick = () => {
            showDlg(false);
            void runAction(
                () => apiSupplierRequests.markDeleted(requestId),
                'supplierRequests.messMarkedDeleted',
            );
        };

        showDlg({
            type: 'confirm',
            buttons,
            text: (
                <>
                    <h4 className="d-flex pb-2 mb-2 border-bottom text-danger">
                        <SvgTrash className="text-danger" />
                        <span className="ps-2">{t('supplierRequests.confirmDelete')}</span>
                    </h4>
                    {vendorName ? <h5 className="mb-0">{vendorName}</h5> : null}
                </>
            ),
        });
    };

    return {
        confirmMarkDone,
        confirmMarkDeleted,
    };
};

export default useRequestStatusActions;
